<template>
    <div class="sleep-summary">
        <div class="icon">
            <IconBed :size="'2rem'" />
        </div>
        <div class="date">{{getFormatedDate(this.sleepData.bucket)}}</div>
        <div class="details">
            <div class="detail-item">
                <span class="label">Bed Time</span>
                <span class="value">{{formatUnixTimeStamp(this.sleepData.status_start_time)}}</span>
                <span class="change">
                    <IconBedTimeDown :color="'#aabdcf'" v-if="!this.bedTimeDiffDetails.positiveVal" />
                    <IconBedTimeUp :color="'#aabdcf'" v-else /> 
                    {{this.bedTimeDiffDetails.minutes}}m
                </span>
            </div>
            <div class="detail-item">
                <span class="label">Wake Time</span>
                <span class="value">{{formatUnixTimeStamp(this.sleepData.status_end_time)}}</span>
                <span class="change">
                    <IconBedTimeUp :color="'#aabdcf'" v-if="this.wakeTimeDiffDetails.positiveVal" />
                    <IconBedTimeDown :color="'#aabdcf'" v-else /> 
                    {{this.wakeTimeDiffDetails.minutes}}m
                </span>
            </div>
            <div class="detail-item">
                <div class="variability-title">Bed Time Variability</div>
                <div class="stats-container">
                    <IconSunSet :size="'1.3rem'" />
                    <span>{{this.sleepStats.bedTimeVariability}}m</span>
                </div>
            </div>
            <div class="detail-item">
                <div class="variability-title">Wake Time Variability</div>
                <div class="stats-container">
                    <IconSunRise :size="'1.3rem'" />
                    <span>{{this.sleepStats.wakeTimeVariability}}m</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Utils from "@/helpers/utils";
import DateUtils from "@/helpers/dateUtils";
import Constants from "@/helpers/constants.js";
import IconBed from "@/shared/Controls/Icons/IconBed.vue";
import IconBedTimeDown from "@/shared/Controls/Icons/IconBedTimeDown.vue";
import IconBedTimeUp from "@/shared/Controls/Icons/IconBedTimeUp.vue";
import IconSunRise from "@/shared/Controls/Icons/IconSunRise.vue";
import IconSunSet from "@/shared/Controls/Icons/IconSunSet.vue";

export default {
    name: "SleepInformation",
    components: {
        IconBed,
        IconBedTimeDown,
        IconBedTimeUp,
        IconSunRise,
        IconSunSet,
    },
    props: {
        sleepData: {
            type: Object,
            required: true,
        },
        previousSleep: {
            type: Object,
            required: false,
        },
        sleepStats: {
            type: Object,
            required: false,
        }
    },
    data() {
        return {
            sleepDuration: "0",
            bedTimeDiffDetails: {
                positiveVal: true,
                minutes: 0
            },
            wakeTimeDiffDetails: {
                positiveVal: true,
                minutes: 0
            },
            bedTimeDiff: 0,
            wakeTimeDiff: 0,
        }
    },
    mounted() {
        this.prepareData();
    },
    watch: {
      sleepData() {
        this.prepareData();
      },
      previousSleep() {
        this.prepareData();
      },
    },
    methods: {
        prepareData() {
          let seconds = this.sleepData.sleep_minutes * 60;
          this.sleepDuration = Utils.formatDurationInHrsAndMins(seconds);
          if(this.previousSleep) {
            this.bedTimeDiffDetails = Utils.getTimeDiffInMins(this.sleepData.status_start_time, this.previousSleep.status_start_time);
            this.wakeTimeDiffDetails = Utils.getTimeDiffInMins(this.previousSleep.status_end_time, this.sleepData.status_end_time);
          }
        },
        formatDurationInHrsAndMins(sleepMinutes) {
            let sleepSeconds = sleepMinutes * 60;
            return Utils.formatDurationInHrsAndMins(sleepSeconds);
        },
        getFormatedDate(bucket) {
            return DateUtils.formatDateToProvidedDate(bucket, Constants.TABLE_DOB_FORMAT);
        },
        formatUnixTimeStamp(unixTime) {
           return DateUtils.formatUnixTimeStamp(unixTime).toUpperCase();
        },
    },
};
</script>

<style lang="scss" scoped>
.sleep-summary {
    background-color: #121212;
    color: white;
    text-align: center;
    padding: 1.2rem;
    border-radius: 0.5rem;
    margin: 0 auto;
    height: 100%;
}

.icon {
    background-color: #3a4f5c;
    width: 5rem;
    height: 5rem;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 0.5rem;
    font-size: 2rem;
    color: #aabdcf;
}

.date {
    font-size: 18px;
    margin-bottom: 20px;
}

.details {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.detail-item {
    width: 50%;
    margin-bottom: 1rem;
    text-align: left;
}

.label {
    font-size: 0.75rem;
    color: #aabdcf;
    display: block;
}

.value {
    font-size: 1rem;
    font-weight: bold;
    display: block;
}

.change {
    font-size: 0.75rem;
    color: #aabdcf;
    display: block;
}

.stats-container {
    display: flex;
    align-items: center;
    gap: 0.65rem;
}
.variability-title {
    font-size: 0.75rem;
    color: #aabdcf;
    display: block;
}
</style>